import { gate } from 'hub-http/gates';
import { userInfoSync } from 'hub-http/userInfo';
const BRAND_VOICE_SCOPE = 'brand-voice';
const CASE_STUDY_ACCESS_SCOPE = 'case-study-access';
const CASE_STUDY_READ_SCOPE = 'case-study-read';
const CASE_STUDY_WRITE_SCOPE = 'case-study-write';
const CASE_STUDY_PUBLISH_SCOPE = 'case-study-publish';
const CONTENT_TYPE_SCHEMA_READ_SCOPE = 'content-type-schema-read';
const STRUCTURED_CONTENT_READ = 'structured-content-read';
const CONTENT_TYPE_OPTION_WRITE = 'content-type-option-write';
export const VIEWER_SCOPES = [CASE_STUDY_ACCESS_SCOPE, CASE_STUDY_READ_SCOPE, CONTENT_TYPE_SCHEMA_READ_SCOPE, STRUCTURED_CONTENT_READ];
export const EDITOR_SCOPES = [...VIEWER_SCOPES, CASE_STUDY_WRITE_SCOPE, CONTENT_TYPE_OPTION_WRITE];
export const PUBLISHER_SCOPES = [...EDITOR_SCOPES, CASE_STUDY_PUBLISH_SCOPE];
export const hasGate = gateName => {
  try {
    const {
      gates
    } = userInfoSync();
    return gates.includes(gateName);
  } catch (errror) {
    return false;
  }
};
const hasScope = scopeName => {
  try {
    const auth = userInfoSync();
    return auth.user.scopes.includes(scopeName);
  } catch (error) {
    return false;
  }
};
const hasAllScopes = scopes => {
  return scopes.every(scope => hasScope(scope));
};
export const hasViewerPermission = () => hasAllScopes(VIEWER_SCOPES);
export const hasEditorPermission = () => hasAllScopes(EDITOR_SCOPES);
export const hasPublisherPermission = () => hasAllScopes(PUBLISHER_SCOPES);
export const isUngatedForCaseStudies = () => hasGate('StructuredContentPlatform:CaseStudies');
export const getIsUngatedForScpModuleInsertion = () => hasGate('StructuredContent:InlineModuleInsertion');
export const getIsUngatedForEditorTour = () => hasGate('LFC:CaseStudyEditorTour');
export const getIsUngatedForBreezeAIRebranding = () => hasGate(gate('BreezeAI:Rebranding'));
export const getHasBrandVoiceScope = () => hasScope(BRAND_VOICE_SCOPE);
export const getIsUngatedForCaseStudyImages = () => hasGate(gate('LFC:CaseStudyImages'));
export const getIsUngatedForMLang = () => hasGate(gate('LFC:CaseStudy:MLang'));
export const getIsUngatedForRevisionHistory = () => hasGate(gate('LFC:CaseStudy:RevisionHistory'));